// 收费标准 2标准 3高 4低
const minMaxChargeOptions = [
  {
    id: 2,
    name: "标准"
  },
  {
    id: 3,
    name: "高"
  },
  {
    id: 4,
    name: "低"
  }
];
// 123
const roundOptions = [
  {
    id: 1,
    name: "向上取整",
    decimal: "0"
  },
  {
    id: 2,
    name: "向上取一半整",
    decimal: "1"
  },
  {
    id: 3,
    name: "四舍五入",
    decimal: "3"
  }
];

const destChargeFlagOptions = [
  {
    id: "0",
    name: "目的港"
  },
  {
    id: "1",
    name: "中转港"
  },
  {
    id: "2",
    name: "case by case"
  }
];

const packageTypeOptions = [
  {
    id: 1,
    name: "CTN(S)"
  },
  {
    id: 2,
    name: "PLT(S)"
  }
];

export const payTypeOptions = [
  {
    id: 1,
    name: "预付",
    nameEn:'Prepaid'
  },
  {
    id: 2,
    name: "到付",
    nameEn:'Pay on arrival'
  },
  {
    id: 3,
    name: "预付/到付",
    nameEn:'Prepaid/Arrival'
  }
];
export const goodsTypeOptions = [
  {
    id: 1,
    name: "同行",
    nameEn:'Co-loader'
  },
  {
    id: 2,
    name: "直客",
    nameEn:"Retailer"
  }
];
export const maintainConsigneeOptions = [
  {
    id: 1,
    name: "同行",
    nameEn:'Co-loader'
  },
  {
    id: 2,
    name: "直客",
    nameEn:"Retailer"
  },
  {
    id: 3,
    name: "同行/直客",
    nameEn:'Co-loader/Retailer'
  }
];

export { minMaxChargeOptions, roundOptions, destChargeFlagOptions,packageTypeOptions };
